<template>
  <div>

    <h1 class="title d-sm-none text-center" :class="ativo==true?null:'red--text'">{{ $route.meta.breadCrumb }}</h1>

    <v-card class="mb-1">
      <!-- Toolbar -->
      <v-toolbar dense flat dark color="blue-grey darken-3">
        <v-toolbar-title class="d-none d-sm-block" :class="ativo==true?null:'red--text'">{{ $route.meta.breadCrumb }}</v-toolbar-title>
        <v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>
        
        <v-text-field v-model="dataTable.search" append-icon="mdi-magnify" label="Filtrar" single-line hide-details></v-text-field>

        <ArrayToExcel v-if="dados.length > 0" :dados="dados" :excel="excel"/>

      </v-toolbar>

      <!-- Toolbar -->
      <v-sheet dark color="blue-grey darken-4 pl-4 pr-4">
				<v-form ref="form">
					<v-row class="pt-2">
						<v-col cols="12" md="4">
							<v-menu
								ref="startDate"
								v-model="startDateMenu"
								:close-on-content-click="false"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="startDate"
										label="Data inicial"
										prepend-icon="mdi-calendar"
										readonly
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="startDate"
									:active-picker.sync="startDateActivePicker"
									@change="startDateMenu=false"
								></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" md="2">
							<v-menu
								ref="startTime"
								v-model="startTimeMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="startTime"
								transition="scale-transition"
								offset-y
								max-width="290px"
								min-width="290px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="startTime"
										label="Hora inicial"
										prepend-icon="mdi-clock-time-four-outline"
										readonly
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-time-picker
									v-if="startTimeMenu"
									v-model="startTime"
									full-width
									@click:minute="$refs.startTime.save(startTime)"
								></v-time-picker>
							</v-menu>
						</v-col>

						<v-col cols="12" md="4">
							<v-menu
								ref="endDate"
								v-model="endDateMenu"
								:close-on-content-click="false"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="endDate"
										label="Data final"
										prepend-icon="mdi-calendar"
										readonly
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="endDate"
									:active-picker.sync="endDateActivePicker"
									@change="endDateMenu=false"
								></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" md="2">
							<v-menu
								ref="endTime"
								v-model="endTimeMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="endTime"
								transition="scale-transition"
								offset-y
								max-width="290px"
								min-width="290px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										v-model="endTime"
										label="Hora final"
										prepend-icon="mdi-clock-time-four-outline"
										readonly
										v-bind="attrs"
										v-on="on"
									></v-text-field>
								</template>
								<v-time-picker
									v-if="endTimeMenu"
									v-model="endTime"
									full-width
									@click:minute="$refs.endTime.save(endTime)"
								></v-time-picker>
							</v-menu>
						</v-col>
					</v-row>

					<v-row>
						<v-col cols="12" sm="8">
							<v-autocomplete
								v-model="periodo"
								:items="periodos"
								item-text="curso_periodo"
								item-value="id"
								label="Curso periodo"
								placeholder="Selecione um curso periodo"
								return-object
								:rules="[rules.required]"
							>
								<template v-slot:item="data">
									{{ data.item.curso }} - 
									{{ data.item.inicio }} - {{ data.item.fim }}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" sm="4">
							<v-btn color="blue darken-1" dark @click="initialize" class="mt-4">
								<v-icon left>fas fa-search</v-icon> Filtrar
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
      </v-sheet>
    </v-card>
    
    <!-- DataTable -->
		<DataTable :dados="dados" :dataTable="dataTable" class="mt-4"/>
		
		<br><br>

	</div>
</template>

<script>
import { mapState } from 'vuex'

import ArrayToExcel from '@/components/ArrayToExcel'
import DataTable from '@/components/DataTable'

export default {
  components: {
    ArrayToExcel,
    DataTable,
  },
	data () {
    return {
      ativo: true,
      dados: [],
      dataTable: {
        headers: [
          {	text: 'ID', value: 'id' },
          { text: 'Nome', value: 'nome', align: 'start'},
          { text: 'Cpf', value: 'cpf' },
          { text: 'Data cad', value: 'datacad' },
        ],
        sortBy: 'datacad',
        sortDesc: false,
        multiSort: false,
        search: '',
        loading: true
      },
      excel: { 
        name: undefined,
        fields: {
          'Id': 'id',
          'Nome': 'nome',
          'Cpf': 'cpf',
          'Curso periodo': 'curso_periodo',
          'Data cad': 'datacad'
        }
      },
			startDate: null,
			startDateActivePicker: null,
			startDateMenu: false,
			startTime: null,
			startTimeMenu: false,
			endDate: null,
			endDateActivePicker: null,
			endDateMenu: false,
			endTime: null,
			endTimeMenu: false,
			periodos: [],
			periodo: null,
		}
  },
	watch: {
		startDateMenu (val) {
			val && setTimeout(() => (this.startDateActivePicker = 'YEAR'))
		},
		endDateMenu (val) {
			val && setTimeout(() => (this.endDateActivePicker = 'YEAR'))
		},
	},

  computed: {
    ...mapState(
      ['user', 'rules']
    ),
  },

  created () {
		this.getDadosSelects()
  },

  methods: {
    excelName(){
      this.excel.name = this.$route.meta.breadCrumb+"-"+Date()+".xls"
    },
    initialize(){
			if (this.$refs.form.validate()) {
				let start = ''
				if(this.startDate!=null) start = this.startDate
				if(this.startTime!=null) start = start+' '+this.startTime
				let end = ''
				if(this.endDate!=null) end = this.endDate
				if(this.endTime!=null) end = end+' '+this.endTime
				this.excelName()
				this.dataTable.loading = true
				let formData = new FormData()
				formData.append('menu', 'relatorios')
				formData.append('function', 'get_pessoas_by_empresa')
				formData.append('periodo_id', this.periodo.id)
				formData.append('start', start)
				formData.append('end', end)
				let vd = this
				
				this.$axiosPost.post('functions.php', formData, 
				{ headers: {'Authorization': this.user.token} })
				.then(function (response) {
					if(response.data.error === 0){
						if(response.data.dados != undefined){
							vd.dados = response.data.dados
						}else{
							vd.dados = [];
						}
						setTimeout(function(){ vd.dataTable.loading = false }, 1000)
					}else{
						vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
					}
				}).catch(function(response){
					console.log('ERRO!! '+response);
				})
			}else{
				this.dataTable.loading = false
			}
    },
		getDadosSelects(){
			let formData = new FormData()
			formData.append('menu', 'pessoa_cursos')
			formData.append('function', 'formSelect_pessoa_cursos')
			let vd = this
			
			this.$axiosPost.post('functions.php', formData, 
			{ headers: {'Authorization': this.user.token} })
			.then(function (response) {
				if(response.data.error === 0){
					vd.periodos = response.data.periodos
					vd.initialize()
				}else{
					vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
				}
			}).catch(function(response){
				console.log('ERRO!! '+response);
			})
    },

  },
}
</script>